import React, { useContext } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import { Layout } from 'components'
import { UserContext } from 'contexts'
import { drawerOptions } from 'components/Drawer'

import { Users } from './Users'
import { Admins } from './Admins'
import { DrawerItems } from './DrawerItems'
import { Stores } from './Stores'
import { Memberships } from './Memberships'
import { Download } from './Downloads'
import { Notifications } from './Notifications'
import { Tags } from './Tags'
import { ManualRewards } from './ManualRewards'
import { Dashboard } from './Dashboard'
import { UserPolls } from './UserPoll'
import { AutomaticNotifications } from './AutomaticNotifications'
import { Prizes } from './Prizes'
import { Coupons } from './Coupons'
import { Events } from './Events'
import { ParkingConfigs } from './ParkingConfigs'
import { LegalTexts } from './LegalTexts'

// 🔧 Utilidad para determinar la primera ruta válida
const getDefaultRoute = (roles: string[]): string => {
  const firstAccessible = drawerOptions.find(option =>
    option.roles?.some(role => roles.includes(role)),
  )

  if (!firstAccessible || !firstAccessible.link) return '/not-found'

  return typeof firstAccessible.link === 'string'
    ? firstAccessible.link
    : firstAccessible.link.pathname || '/not-found'
}

const Main: React.FC = () => {
  const { admin } = useContext(UserContext)

  if (!admin) {
    return <Redirect to="/login" />
  }

  const userRoles: string[] = admin.roles.map(role => role.name)

  return (
    <Layout>
      <Switch>
        {/* Redirección dinámica según roles */}
        <Route
          exact
          path="/"
          render={() => {
            const defaultRoute = getDefaultRoute(userRoles)
            return <Redirect to={defaultRoute} />
          }}
        />

        {/* Rutas disponibles */}
        <Route path="/users" component={Users} />
        <Route path="/admins" component={Admins} />
        <Route path="/drawer-items" component={DrawerItems} />
        <Route path="/stores" component={Stores} />
        <Route path="/coupons" component={Coupons} />
        <Route path="/memberships" component={Memberships} />
        <Route path="/rewards-automatizados" component={Prizes} />
        <Route path="/rewards-manuales" exact component={ManualRewards} />
        <Route path="/downloads" component={Download} />
        <Route path="/notifications" component={Notifications} />
        <Route path="/notificaciones/automaticas" component={AutomaticNotifications} />
        <Route path="/tags" exact component={Tags} />
        <Route path="/user-test" exact component={UserPolls} />
        <Route path="/events" exact component={Events} />
        <Route path="/parking-configs" exact component={ParkingConfigs} />
        <Route path="/dashboard" component={Dashboard} />
        <Route path="/app-config" exact component={LegalTexts} />
        <Redirect from="/styles" to="/app-config?tab=styles" />
        <Redirect from="/legal-texts" to="/app-config" />

        {/* Fallback para rutas no válidas */}
        <Route component={() => <h1>404 - Página no encontrada</h1>} />
      </Switch>
    </Layout>
  )
}

export { Main }
